"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteractionName = void 0;
var InteractionName;
(function (InteractionName) {
    InteractionName["WIDGET_LOAD"] = "widget-load-common";
    InteractionName["WIDGET_LOAD_BY"] = "widget-load-by";
    InteractionName["UPDATE_COUNTRY"] = "update-country";
    InteractionName["RESOLVE_COUNTRY"] = "resolve-country";
    InteractionName["LAZY_COMPONENT_LOAD"] = "lazy-component-load";
    InteractionName["MOUNT_TO_LOADER"] = "mount-to-loader";
    InteractionName["ALE"] = "load";
    InteractionName["ALE_LAZY_MOUNT_TO_LOADER"] = "load-phase-loader";
    InteractionName["ALE_LOADER_TO_PARTIAL_RENDER"] = "load-phase-partial-render";
    InteractionName["ALE_PARTIAL_TO_FULL_RENDER"] = "load-phase-full-render";
    InteractionName["FRAMED_MODAL_ALE"] = "framed-modal-load";
    InteractionName["FRAMED_MODAL_ALE_LOADER"] = "framed-modal-load-phase-loader";
    InteractionName["FRAMED_MODAL_ALE_RENDER"] = "framed-modal-load-phase-render";
    InteractionName["PAY_MODAL_ALE"] = "pay-modal-load";
    InteractionName["SQUARE_3DS_MODAL_MOUNT"] = "square-3ds-modal-mount";
    InteractionName["INSTANT_PAYMENT_MODAL_MOUNT"] = "instant-modal-modal-mount";
    InteractionName["SQUARE_CASH_APP_PAGE_INIT"] = "square-cash-app-page-init";
    InteractionName["SQUARE_CASH_APP_SUBMIT_RESULT"] = "square-cash-app-submit-result";
    InteractionName["INIT_SDK"] = "init-sdk";
    InteractionName["INIT_BI"] = "init-bi";
    InteractionName["LOAD_SETTINGS"] = "load-settings";
    InteractionName["LOAD_PAYMENT_METHOD_TYPES"] = "load-payment-method-types";
    InteractionName["CHARGE_ORDER_BY_CREDIT_CARD_MODULE"] = "charge-order-by-credit-card-module";
    InteractionName["CHARGE_ORDER_BY_WALLET_MODULE"] = "charge-order-by-wallet-module";
    InteractionName["CHARGE_ORDER_BY_OFFLINE_MODULE"] = "charge-order-by-offline-module";
    InteractionName["CHARGE_ORDER_BY_IN_PERSON_MODULE"] = "charge-order-by-in-person-module";
    InteractionName["CHARGE_ORDER_BY_APPLE_PAY_MODULE"] = "charge-order-by-apple-pay-module";
    InteractionName["CHARGE_ORDER_BY_STRIPE_MODULE"] = "charge-order-by-stripe-module";
    InteractionName["CREATE_PAYMENT_DETAILS"] = "create-payment-details";
    InteractionName["LOAD_ZDP_SCRIPT"] = "load-zdp-script";
    InteractionName["SETUP_ZERO_CHARGE_ORDER"] = "setup-zero-charge-order";
    InteractionName["FIND_AGREEMENT_ID"] = "find-agreement-id";
    InteractionName["CAPTCHA_LOAD_AND_RENDER"] = "captcha-load-and-render";
    InteractionName["CAPTCHA_SDK_LOAD"] = "captcha-sdk-load";
    InteractionName["CAPTCHA_SDK_READY"] = "captcha-sdk-ready";
    InteractionName["CAPTCHA_SECONDARY_RENDER"] = "captcha-secondary-render";
    InteractionName["APPLE_PAY_VALIDATE_MERCHANT"] = "apple-pay-validate-merchant";
    InteractionName["APPLE_PAY_PAYMENT_SESSION"] = "apple-pay-payment-session";
    InteractionName["APPLE_PAY_CREATE_RECURRING_REQUEST"] = "apple-pay-create-recurring-request";
    InteractionName["APPLE_PAY_CREATE_DEFERRED_REQUEST"] = "apple-pay-create-deferred-request";
    InteractionName["STRIPE_JS_SDK_LOAD"] = "stripe-js-sdk-load";
    InteractionName["STRIPE_ELEMENTS_CREATE_CONFIRMATION_TOKEN"] = "stripe-elements-create-confirmation-token";
    InteractionName["STRIPE_ELEMENTS_MOUNT"] = "stripe-elements-mount";
    InteractionName["STRIPE_ELEMENTS_SUBMIT"] = "stripe-elements-submit";
})(InteractionName || (exports.InteractionName = InteractionName = {}));
//# sourceMappingURL=InteractionName.js.map